import { SourceToggleMode } from "components/markdownEditor/types";
import { useOrgUserProfileCookie } from "utils/profileCookie";

import { MARKDOWN_SOURCE_TOGGLE_MODES } from "../consts";

// HACK: this is a quick fix to let Porsche's automation bot to do its job,
// after we introduced the rich markdown editor.
// The bot is not able to handle the rich editor, so we need to switch to the source mode by default
// for specific bot users (see MARKDOWN_SOURCE_TOGGLE_MODES below).
//

// This is going to be removed in sc-30043 (https://app.shortcut.com/impero/story/30043).
export function useMarkdownSourceToggleMode(): SourceToggleMode | undefined {
    const userProfile = useOrgUserProfileCookie();

    if (!userProfile) {
        return undefined;
    }
    const userId = userProfile.userId;
    const domain = window.location.hostname;

    const domainModes = MARKDOWN_SOURCE_TOGGLE_MODES[domain];
    if (!domainModes) {
        return undefined;
    }
    const mode = domainModes[userId];
    if (!mode) {
        return undefined;
    }
    return mode;
}
